import {lazy, trigger, filter} from './lang.js';
import {doc} from './documentation.js';

doc(
    "loop",
    {
        "length": "how long to loop",
        "mode": "mode from 0-1"
    },
    "Loops triggers at a loop-size. Modes are 0=off 0.5=record 1=play"
);

export const OFF = 0;
export const RECORD = 0.5;
export const PLAY = 1;

const getMode = (mode) => {
    if (mode < 0.33) {
        return OFF;
    } else if (mode < 0.66) {
        return RECORD;
    } else {
        return PLAY;
    }
};
export const loop = (length, mode) => {
    let tape = [];
    let counter = 0;

    const record = (stepData, time, length) => {
        tape.push({stepData, time});
    };

    return (... args) => {
        let time = args[2];
        let stepNumber = args[1];
        let currentTime = args[3].currentTime;

        let _length = Math.round(lazy(length, ...args));
        let _mode = getMode(lazy(mode, ...args));

        switch (_mode) {
        case RECORD:
            record(args[0], time - currentTime, _length);
            return filter(true);
        case PLAY:
            let start = tape.length - _length;
            let _counter = (counter++) % _length;
            let trigToPlay = tape[start + _counter];
            if (!trigToPlay.stepData) {
                return filter(false);
            }
            return trigger({
                ... trigToPlay,
                stepNumber,
                time: time + trigToPlay.time
            });
        default:
            return filter(true);
        }
    };
};
